import React from "react";
// import { Result } from 'antd';
// import { Icon } from 'semantic-ui-react';
// // import { MehOutlined } from '@ant-design/icons';
import "./styles.scss";

function BiGerencial() {
  React.useEffect(() => {}, []);

  return (
    <React.Fragment>
      <div class="embed-container">
        {/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
        <iframe
          // src="https://ig-analytics.com/"
          src="https://analytics-webapp.com/"
          frameborder="0"
          allowfullscreen
        ></iframe>
      </div>
    </React.Fragment>
  );
}

export default BiGerencial;
